const BASE = '/api';

function getToken() {
  return localStorage.getItem('simlog_token');
}

function headers() {
  return {
    'Content-Type': 'application/json',
    ...(getToken() ? { Authorization: 'Bearer ' + getToken() } : {})
  };
}

function toParams(obj) {
  return new URLSearchParams(
    Object.fromEntries(
      Object.entries(obj || {}).filter(([, v]) => v !== undefined && v !== null && v !== '')
    )
  );
}

async function request(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: headers(),
    body: body ? JSON.stringify(body) : undefined
  });
  if (res.status === 401) {
    localStorage.removeItem('simlog_token');
    window.location.href = '/';
    return;
  }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  login:          (email, password) => request('POST', '/login', { email, password }),
  changePassword: (currentPassword, newPassword) => request('POST', '/change-password', { currentPassword, newPassword }),

  instructors: {
    list:    ()      => request('GET',  '/instructors'),
    listAll: ()      => request('GET',  '/instructors?all=1'),
    create:  (data)  => request('POST', '/instructors', data),
    update:  (id, d) => request('PUT',  `/instructors/${id}`, d)
  },

  students: {
    list:    ()      => request('GET',  '/students'),
    listAll: ()      => request('GET',  '/students?all=1'),
    create:  (data)  => request('POST', '/students', data),
    update:  (id, d) => request('PUT',  `/students/${id}`, d)
  },

  sessions: {
    list:       (params)  => request('GET',    '/sessions?' + toParams(params)),
    get:        (id)      => request('GET',    `/sessions/${id}`),
    lastHobbs:  ()        => request('GET',    '/sessions/last-hobbs'),
    create:     (data)    => request('POST',   '/sessions', data),
    update:     (id, d)   => request('PUT',    `/sessions/${id}`, d),
    manageSquawk: (id, d) => request('PUT',    `/sessions/${id}/squawk`, d),
    delete:     (id)      => request('DELETE', `/sessions/${id}`)
  },

  reports: {
    instructorTime: (p) => request('GET', '/reports/instructor-time?' + toParams(p)),
    pilotTime:      (p) => request('GET', '/reports/pilot-time?'      + toParams(p)),
    squawk:         (p) => request('GET', '/reports/squawk?'          + toParams(p))
  },

  trainingTypes: {
    list:    ()      => request('GET',  '/training-types'),
    listAll: ()      => request('GET',  '/training-types?all=1'),
    create:  (data)  => request('POST', '/training-types', data),
    update:  (id, d) => request('PUT',  `/training-types/${id}`, d)
  },

  users: {
    list:   ()     => request('GET',  '/users'),
    create: (data) => request('POST', '/users', data)
  }
};
